import React, { FC } from 'react';

interface IInput {
  label?: string;
  type?: string;
  name: string;
  placeholder?: string;
  value?: string | boolean | number;
  id?: number;
  errors?: string | boolean;
  action?: (id: number, value: string) => void;
  onChangeForm?: (name: string, value: string) => void;
}

const Input: FC<IInput> = ({
  label,
  type,
  name, placeholder,
  action,
  id,
  onChangeForm,
  errors,
}): React.ReactElement => {

  return (
    <div className='input'>
      {label ? <label className='input__label' htmlFor={name}>{label}</label> : <></>}

      {type !== 'static'
        ?
        <input
          onBlur={(e) => action!(id as number, e.target.value)}
          className={`input__body ${errors ? 'isError' : ''}`}
          placeholder={placeholder}
          name={name}
        />
        : name !== 'date'
          ?
          <input
            onBlur={(e) => onChangeForm!(name, e.target.value)}
            className={`input__body ${errors ? 'isError' : ''}`}
            placeholder={placeholder}
            name={name}
          />
          :
          <input
            onBlur={(e) => onChangeForm!(name, e.target.value)}
            className={`input__body ${errors ? 'isError' : ''}`}
            placeholder={placeholder}
            name={name}
            //@ts-ignore
            value={new Date().toLocaleDateString()}
            style={{ pointerEvents: 'none' }}
          />
      }
      {errors ? <h1 className='input__error'>Empty field</h1> : <></>}


    </div>
  );
};

export { Input };
